import "./css/all.scss";
export default function Icon({
  name,
  className,
  size,
  styleFamily,
  onClick,
  style
}:{
  name:string,
  className?:string,
  size?:"2xs"|"xs"|"sm"|"lg"|"xl"|"2xl",
  styleFamily?:"solid"|"regular"|"light"|"thin"|"duotone"|"brands",
  onClick?:()=> void | undefined,
  style?:any
}){

  function getStyleFamily(styleFamily?:"solid"|"regular"|"light"|"thin"|"duotone"|"brands"){
    if(styleFamily){
      if(styleFamily === "solid") return "fas"; 
      if(styleFamily === "regular") return "far"; 
      if(styleFamily === "light") return "fal"; 
      if(styleFamily === "thin") return "fat"; 
      if(styleFamily === "duotone") return "fad"; 
      if(styleFamily === "brands") return "fab"; 
    }
    return "fas";
  }

  function getSize(size?:"2xs"|"xs"|"sm"|"lg"|"xl"|"2xl"){
    if(size){
      return " fa-"+size;
    }
    return "";
  }

  function getClassName(className?:string){
    if(className){
      return " "+className;
    }
    return "";
  }

  return (
    <i className={`${getStyleFamily(styleFamily)} fa-${name}${getSize(size)}${getClassName(className)}`} onClick={onClick} style={style}></i>
  );
}